// Dependencies
import styled from 'styled-components'

export const Container = styled.div`
  display: block;
  box-sizing: border-box;
  background: #fff;
  padding: 40px;
  position: fixed;
  top: 0px;
  left: 100%;
  width: 100%;
  height: 100%;
  z-index: 9;
  transition: left 0.4s ease 0s;
  left: 0;

  .wrapper-header {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
`
